import { render, staticRenderFns } from "./stepSucces.vue?vue&type=template&id=42b8438a&scoped=true&"
import script from "./stepSucces.vue?vue&type=script&lang=js&"
export * from "./stepSucces.vue?vue&type=script&lang=js&"
import style0 from "./stepSucces.vue?vue&type=style&index=0&id=42b8438a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8438a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VImg,VSheet})
